export class InDayHourlyBookingMetaValue {
  times: number[];
  date: string;

  constructor(date?: string, times?: number[]) {
    this.date = date;
    this.times = times;
  }
}
